/* eslint-disable no-console */

export const fetchToken = async (context = {}) => {
  try {
    const body = Object.keys(context).length > 0 ? { context } : {};
    const res = await fetch('/ai/chatkit_tokens', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error();
    const data = await res.json();
    return { token: data.token, flowType: data.flow_type };
  } catch (error) {
    console.error('Error fetching ChatKit token:', error);
    return null;
  }
};
